module.exports = {
	"articleTitle1": "Trotter Center workshop links feminism to environmental justice ...",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "Oxford Community Center",
	"articleLink1": "https://www.michigandaily.com/section/news/community-discusses-feminism-and-climate-change-trotter",
	"articleLink2": "https://www.michigandaily.com/section/news-briefs/daily-fake-news-travels-fast",
	"articleSnippet1": "Feb 1, 2017 ... The program originated last fall in the Sustainable Living Experience learning \ncommunity in the Oxford residence hall. According to the group's ...",
	"articleSnippet2": "Apr 4, 2017 ... A study by researchers at Oxford University in London found Twitter feeds ... Ann \nArbor's Hebrew Day School latest Jewish community center to ...",
	"totalMisc": 0,
	"articleTitle2": "On the Daily: Fake news travels fast ",
	"address": "623 Oxford Rd, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.274333,
		"lng": -83.725801
	},
	"tips": [],
	"bathroomrating": [],
	"categories": {
		"dorm": 1,
		"misc": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/oxford.json
// module id = 939
// module chunks = 0